import React, { useContext, useState } from 'react';
import { auth, googleProvider } from '../config/firebase';
import { signInWithPopup } from 'firebase/auth';
import { Button } from 'antd';
import { setStorageItem } from '../helpers/localStorage';
import { UserDispatchContext } from '../store/user';
import { Google } from '../icons/Google';
import { EMPLOYEE_EMAILS } from '../helpers/constants';

export const Login = () => {
    const dispatch = useContext(UserDispatchContext);
    const [errorMessage, setErrorMessage] = useState('');

    const signInWithGoogle = async () => {
        try {
            await signInWithPopup(auth, googleProvider);
            const userEmail = auth?.currentUser?.email;
            if (EMPLOYEE_EMAILS.includes(userEmail)) {
                setStorageItem('userEmail', auth?.currentUser?.email);
                dispatch({
                    type: 'ADD_USER',
                    email: auth?.currentUser?.email,
                });
            } else {
                setErrorMessage(
                    `Email "${userEmail}" is not found. Please contact the administrator.`
                );
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                flexDirection: 'column',
                gap: 20,
            }}
        >
            <h1>Nord Collection</h1>
            <Button
                onClick={signInWithGoogle}
                type='default'
                icon={<Google />}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 20,
                    height: 50,
                }}
            >
                Login with google
            </Button>
            <h4 style={{ color: 'red' }}>{errorMessage}</h4>
        </div>
    );
};
